import DashboardLight from './../assets/img/icon/dashbaord_light.webp'
import DashboardDark from './../assets/img/icon/dashboard_dark.webp'
import CoursesLight from './../assets/img/icon/courses_light.webp'
import CoursesDark from './../assets/img/icon/courses_dark.webp'
import ExploreLight from './../assets/img/icon/explore_light.webp'
import ExploreDark from './../assets/img/icon/explore_dark.webp'
import MomentLight from './../assets/img/icon/moment_light.webp'
import MomentDark from './../assets/img/icon/moment_dark.webp'
import PiggyBankLight from './../assets/img/icon/piggy_bank_light.webp'
import PiggyBankDark from './../assets/img/icon/piggy_bank_dark.webp'
import LogoutLight from './../assets/img/icon/logout_light.webp'
import LogoutDark from './../assets/img/icon/logout_dark.webp'
import CourseImg from './../assets/img/course_img-new.jpg'
import PiggyDark from './../assets/img/icon/piggy_dark.webp'
import MoreVerticalOps from './../assets/img/icon/moreoption.webp'
import RelatedCourseImg from './../assets/img/related_course_img-new.jpg'
import PeopleMore from './../assets/img/icon/people_dark.webp'
import Location from './../assets/img/icon/location1.png'
import EventAvatar from './../assets/img/event_avatar-new.jpg'
import CarouselImg from './../assets/img/carousel_img-new.jpg'
import CarouselImg1 from './../assets/img/carousel_img2-new.jpg'
import StudentProfileBG from './../assets/img/bgimg/student_profile_bgimg.jfif'
import MemoryImg1 from './../assets/img/memory_img1-new.jpg'
import MemoryImg2 from './../assets/img/memory_img2-new.jpg'
import MemoryImg3 from './../assets/img/memory_img3-new.jpg'
import MemoryImg4 from './../assets/img/memory_img4-new.jpg'
import SchoolBag from './../assets/img/school_bag-new.jpg'
import ExpandMore from './../assets/img/icon/expand_more.webp'
import ExpandLess from './../assets/img/icon/expand_less.webp'
import SettingIcon from './../assets/img/icon/setting.webp'
import NotificationIcon from './../assets/img/icon/notification.webp'
import SearchIcon from './../assets/img/icon/search.webp'
import Bottel1 from './../assets/img/pro_water_bottal-new.jpg'
import Bottel2 from './../assets/img/pro_water_bottal1-new.jpg'
import Pencil from './../assets/img/pro_color_pencil-new.jpg'
import Shoes from './../assets/img/pro_shoes-new.jpg'
import Shoes1 from './../assets/img/pro_shoes1-new.jpg'
import StudentPic from './../assets/img/student_pic-new.jpg'
import FancyDressCom from './../assets/img/fancy_dress_com-new.jpg'
import WaterColouringCom from './../assets/img/water_colouring-new.jpg'
import DanceCom from './../assets/img/dance_competetion-new.jpg'
import Sparkal from './../assets/img/sparkal-new.jpg'
import RelComputer from './../assets/img/rel_computer-new.jpg'
import RelBookPen from './../assets/img/rel_bookpen-new.jpg'
import PencilBookedEve from './../assets/img/pencil_booked_event-new.jpg'
import DrawingBookedEve from './../assets/img/drawing_booked_event-new.jpg'
import NotificationDark from './../assets/img/icon/notification_dark.webp'
import SettingDark from './../assets/img/icon/setting_dark.webp'
import FilterDark from './../assets/img/icon/filter_dark.webp'
import PiggyPicture from './../assets/img/icon/piggy_picture-new.png'
import CoinedImg from './../assets/img/coined_img-new.jpg'
import Stack from './../assets/img/icon/stack.png'
import transactionAvatar1 from './../assets/img/transaction_avatar1.jpg'
import transactionAvatar2 from './../assets/img/transaction_avatar2-new.jpg'
import transactionAvatar3 from './../assets/img/transaction_avatar3-new.jpg'
import PoorEmoji from './../assets/img/icon/poor_emoji.png'
import PerfectEmoji from './../assets/img/icon/perfect_emoji-new.png'
import GoodEmoji from './../assets/img/icon/good_emoji-new.png'
import VeryPoorEmoji from './../assets/img/icon/verypoor_emoji-new.png'
import ListIcon from './../assets/img/icon/list_icon.webp'
import TotalPayOut from './../assets/img/icon/total_payout.png'
import ViewAttendace from './../assets/img/icon/view_attendance.webp'
import UploadImg from './../assets/img/icon/upload_img.webp'
import ViewStudent from './../assets/img/icon/review_stu.webp'
import CompletedImg from './../assets/img/completed_img.webp'
import TextBgImg from './../assets/img/text_background_img-new.jpg'
import ApartmentBg from './../assets/img/apartment_bg-new.jpg'
import PurchasedImg from './../assets/img/PurchasedCourse-new.png'
import PurchasedSprint from './../assets/img/PurchasedSprints-new.jpg'
import DefaultImage from "./../assets/img/DefaultImg.png"

import BookedEventPlaceholder from './../assets/img/bookedEvents.png'
import YoutubIcon from './../assets/img/icon/youtubIcon.png'
import PdfIcon from './../assets/img/icon/pdfIcon.png'

export class Constants {
    static customImages = {
        DashboardLight,
        DashboardDark,
        CoursesLight,
        CoursesDark,
        ExploreLight,
        ExploreDark,
        MomentLight,
        MomentDark,
        PiggyBankLight,
        PiggyBankDark,
        LogoutLight,
        LogoutDark,
        CourseImg,
        PiggyDark,
        MoreVerticalOps,
        RelatedCourseImg,
        PeopleMore,
        Location,
        EventAvatar,
        CarouselImg,
        CarouselImg1,
        StudentProfileBG,
        MemoryImg1,
        MemoryImg2,
        MemoryImg3,
        MemoryImg4,
        SchoolBag,
        ExpandMore,
        ExpandLess,
        SettingIcon,
        NotificationIcon,
        SearchIcon,
        Bottel1,
        Bottel2,
        DefaultImage,
        Shoes,
        Shoes1,
        Pencil,
        StudentPic,
        FancyDressCom,
        WaterColouringCom,
        DanceCom,
        Sparkal,
        RelBookPen,
        RelComputer,
        PencilBookedEve,
        DrawingBookedEve,
        NotificationDark,
        SettingDark,
        FilterDark,
        PiggyPicture,
        CoinedImg,
        Stack,
        transactionAvatar1,
        transactionAvatar2,
        transactionAvatar3,
        PoorEmoji,
        PerfectEmoji,
        GoodEmoji,
        VeryPoorEmoji,
        ListIcon,
        TotalPayOut,
        // Logo,
        CompletedImg,
        TextBgImg,
        ApartmentBg,
        PurchasedImg,
        PurchasedSprint,
        BookedEventPlaceholder


    };

    static customIcon = {
        ViewAttendace,
        UploadImg,
        ViewStudent,
        YoutubIcon,
        PdfIcon
    }

}



export const Page_Padding = { xs: "20px", sm: "30px", md: "80px" };
export const BOX_SHADOW = "0px 8px 16px 0px #4169E11A"

export const Blue_Border = "1px solid #4169E1"

export const Grid_Gap = "15px"
export const Grid_Gap_LG = "30px"

export const Form_Padding = { sm: "20px 15px", xs: "5px 10px" }

export const Frontend_URL = window._env_?.REDIRECT_URL || ""

export const Domain = window._env_?.DOMAIN || ""

export const Website_Url = window._env_?.REDIRECT_URL || ""


// export const Frontend_URL = "https://test.myskill.club/web/"

// export const Frontend_URL = "https://myskill.club/"

// export const Frontend_URL = "http://localhost:3000/web/"

// export const Domain = ".test.myskill.club"

// export const Domain = ".myskill.club"

// export const Domain = ""

export const ImagePath = window._env_?.IMAGE_PATH || ""

export const Input_Width = { xs: 12, sm: 6, md: 4 }

export const Input_Width_LG = { xs: 12, sm: 6, md: 6 }



export const apiUrlShop = window._env_?.API_PATH_SHOP;


export const apiUrlNode = window._env_?.API_PATH_NODE;

export const Main_URL = window._env_?.WEBSITE_PATH_SHOP_TIMES


export const AI_LMS_PATH = window._env_?.AI_LMS_PATH
export const ImagePathNode = window._env_?.IMAGE_PATH_NODE; 
export const getFileUrl = (path) => `${ImagePathNode}/${path}`;

export const ImageRelativePath = "assets/images/event/cover/"



